import { render, staticRenderFns } from "./CommonPerksGallery.vue?vue&type=template&id=94065a04&scoped=true&"
import script from "./CommonPerksGallery.vue?vue&type=script&lang=ts&"
export * from "./CommonPerksGallery.vue?vue&type=script&lang=ts&"
import style0 from "./CommonPerksGallery.vue?vue&type=style&index=0&id=94065a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94065a04",
  null
  
)

export default component.exports